import { ContextMenu, IconButton, Input, LeftSideList, MenuItem, MenuList, SideHeader, TnModal } from 'bimui';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ReactComponent as AddSvg } from 'bimui/dist/c1/icons/add.svg';
import { ReactComponent as BindSvg } from 'bimui/dist/c1/icons/bind.svg';
import { ReactComponent as UploadSvg } from 'bimui/dist/c1/icons/upload.svg';
import "./index.less"
import { addGroup, deleteGroup, getGroups, getTreeGroups, GroupThumbnailUploadUrl, updateGroup } from '@/declare/api/geometry/group';
import { EngineContext, RegisterContext } from '@/App';
import { Group } from '@/declare/interface/project/group';
import { DataChangeStruct, PythaEventName, UpdateType, PythaEventText, PythaEventStringArray } from 'pytha2';
import { Tooltip, Upload, message } from 'antd';
import GroupItem from './group-item';
import { BaseUtils } from 'tnbase';
import localStore from '@/store/local-store';
import { RegisterStatus } from '@/store/register-store';
import { getMajorFileByProjectUuid } from '@/declare/api/project/file';
import TreeComponent, { TreeNode } from '../param/tree';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import { GroupParamType } from '@/declare/enums/group-param-type';
import { SIDEBAR_TYPE } from '@/declare/enums/menu-type';
import classNames from 'classnames';

/**
 * 组的侧边栏
 * @returns 
 */
export default function GroupPanel() {
    const navigate = useNavigate();
    const { projectUuid, modelUuid } = useParams();
    const { emitCommand, engine } = useContext(EngineContext);
    const [groups, setGroups] = useState<Group[]>([]);
    const [activeGroupKey, setActiveGroupKey] = useState<string>();

    const [contextMenuLeft, setContextMenuLeft] = useState<number>(0) // 添加选项弹窗的左方位置
    const [contextMenuTop, setContextMenuTop] = useState<number>(0) // 添加选项弹窗的上方位置
    const [contextMenuVisible, setContextMenuVisible] = useState<boolean>(false) // 添加选项弹窗是否可见

    const [activeRootGroup, setActiveRootGroup] = useState<Group>(); // 左侧激活的一级组
    const [selectedSubItem, setSelectedSubItem] = useState<Group>(); // 当前选中的组，用于新增子组
    const [leftItemUpdateUuid, setLeftItemUpdateUuid] = useState<string>(null);   //左侧分类更新uuid

    const [editUuid, setEditUuid] = useState<string>(null);   //重命名uuid
    const [inputValue, setInputValue] = useState<string>(null);   //输入框的值

    const [ctxVisible, setCtxVisible] = useState<boolean>(false);   //右侧树对象右键菜单是否显示
    const [rootGroupCtxOpen, setRootGroupCtxOpen] = useState<boolean>(false);   // 一级分组的右键菜单是否显示
    const [ctxUuid, setCtxUuid] = useState<string>(null);   //右键菜单的uuid
    const [ctxLeft, setCtxLeft] = useState<number>(0);   //菜单left
    const [ctxTop, setCtxTop] = useState<number>(0);   //菜单top

    const [thLeft, setThLeft] = useState<number>(0) // 缩略图弹窗的左方位置
    const [thTop, setThTop] = useState<number>(0) // 缩略图弹窗的上方位置
    const [thVisible, setThVisible] = useState<boolean>(false) // 缩略图弹窗是否可见

    const [selectedNodes, setSelectedNodes] = useState<TreeNode[]>([]); // 被选择的节点

    const selectedNodesRef = useRef(selectedNodes);

    const groupsRef = useRef(groups);

    /**
     * 树源数据
     */
    const [treeData, setTreeData] = useState<TreeNode[]>([])
    /**
     * 激活的节点
     */
    // const [activeNode, setActiveNode] = useState<TreeNode>(null)
    /**
     * 添加后需要展开的父项
     */
    const [showItemKey, setShowItemKey] = useState<string>()
    /**
     * 编辑信号
     */
    const [editFlag, setEditFlag] = useState<string>();
    /**
     * 删除信号
     */
    const [deleteFlag, setDeleteFlag] = useState<string>();

    const registerContext = useContext<RegisterStatus>(RegisterContext);
    const dbClickRef = useRef(false); // 双击标记

    const [isActiveGroupEdit, setIsActiveGroupEdit] = useState<boolean>(false); // 激活组编辑

    useEffect(() => {
        // 监听引擎事件
        const unsubscribe = engine?.eventMediator?.noticeHandler?.onNotice?.subscribe((sender, event) => {
            if (event.cmd === PythaEventName.NOTICE) {
                let data = event?.data as string;
                if (!data) return;
                if (data.includes("结束")) {
                    setIsActiveGroupEdit(false);
                }
            }
            if (event.cmd === PythaEventName.DATA_CHANGE) {
                let data = event?.data as DataChangeStruct;
                if (!data) return;

                if (data.update_group != null) {
                    // 更新组
                    let activeNode = selectedNodesRef.current.length > 0 ? selectedNodesRef.current[0] : null;
                    if (!activeNode) return;
                    // 查询当前组的子组uuid
                    let groupUuids = [];
                    getAllKeysRecursiveByRootNodes(activeNode.children, groupUuids);
                    if (data.add_primitives && data.add_primitives.length > 0) {
                        // 有更新的图元
                        // 新添加到这个组的图元数量
                        let addCount = 0;
                        let addPrimitives = [];
                        // 从这个组中移除的图元数量
                        let deleteCount = 0;
                        let deletePrimitives = [];
                        data.add_primitives.forEach(pri => {
                            if (pri?.group?.includes(activeNode.key)) {
                                // 在当前组中
                                if (!groupUuids.some(uuid => pri?.group?.includes(uuid))) {
                                    // 不在子组中，新添加的
                                    addCount += 1;
                                    addPrimitives.push(pri);
                                }
                            } else {
                                // 也不在子组中
                                if (!groupUuids.some(uuid => pri?.group?.includes(uuid))) {
                                    deleteCount += 1;
                                    deletePrimitives.push(pri);
                                }
                            }
                        })
                        // 总的数量变化
                        let changeCount = addCount - deleteCount;
                        // 更新primitiveCount
                        let success = updateGroupPrimitiveCountToParentRecursive(activeNode.key, groupsRef.current, changeCount, activeNode.key, addPrimitives, deletePrimitives);
                        if (success) {
                            setGroups([...groupsRef.current]);
                        }
                    }
                }
            }
        });

        return () => {
            unsubscribe?.();
        };
    }, [projectUuid]);

    /**
     * 查询targetUuid对应组及其上级组
     */
    const getSelfAndParentGroups = (targetUuid: string, groups: Group[], parentGroups: Group[]) => {
        // 遍历 groups 数组
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            // 如果找到目标节点
            if (group?.uuid === targetUuid) {
                parentGroups.push(group);
                return true;
            }
            // 如果当前组有子组，则递归查找子组
            if (group?.children && group?.children?.length > 0) {
                const found = getSelfAndParentGroups(targetUuid, group.children, parentGroups);
                // 如果子组中找到并成功更新，直接返回 true
                if (found) {
                    parentGroups.push(group);
                    return true;
                }
            }
        }
        return false;
    }

    useEffect(() => {
        let status = localStore.getSidebarStatus(SIDEBAR_TYPE.MODEL);
        setActiveRootGroup(status['activeRootGroup'] || null);
        // setSelectedNodes(status['selectedNodes'] || []);
    }, [])

    useEffect(() => {
        if (!modelUuid) {
            let majorUuid = localStore.activeMajor;
            let majorName = registerContext.majors.find(item => item.uuid == majorUuid)?.name || "未命名";
            getMajorFileByProjectUuid(projectUuid, majorUuid, { majorName: majorName }).then(res => {
                let modelUuid = res.data;
                navigate(`/projects/${projectUuid}/models/${modelUuid}`);
            })
        }
    }, [projectUuid, modelUuid])


    useEffect(() => {
        updateStatus(activeRootGroup, selectedNodes);
    }, [activeRootGroup, selectedNodes])

    const updateStatus = (activeRootGroup, selectedNodes) => {
        // 在这里向外传递状态
        let status = {
            activeRootGroup: activeRootGroup,
            // selectedNodes: selectedNodes,
        };
        localStore.setSidebarStatus(SIDEBAR_TYPE.MODEL, status);
    }

    useEffect(() => {
        groupsRef.current = groups;
    }, [groups])

    useEffect(() => {
        selectedNodesRef.current = selectedNodes;
        if (selectedNodes.length == 0) {
            // 显示全部图元
            emitCommand("SHOW_ALL");
            return;
        }
        // 仅显示选中的组包含的图元
        let groupUuids = [];
        getAllKeysRecursiveByRootNodes(selectedNodes, groupUuids);
        if (!engine) return;
        // 按组显示
        const event = new PythaEventStringArray();
        // 去重
        groupUuids = groupUuids.filter((item, index, self) =>
            index === self.findIndex((t) => (
                t === item
            ))
        );
        event.data = groupUuids;
        emitCommand("GROUPSHOW")
        engine.eventMediator?.emitEvent(event)
    }, [selectedNodes])

    /**
     * 获取组列表
     */
    useEffect(() => {
        getTreeGroups(projectUuid, { modelUuid: modelUuid }).then(res => {
            let data: Group[] = res.data || [];
            setGroups(data);
            if (!activeRootGroup && data.length > 0) {
                setActiveRootGroup(data[0]);
            }
        })
    }, [projectUuid, modelUuid]);

    useEffect(() => {
        if (groups?.length === 0 || !activeRootGroup) {
            setTreeData([]);
            return;
        }
        let group: Group = groups?.find(item => item.uuid === activeRootGroup?.uuid);
        let tData = generateTreeData(group?.children || []);
        setTreeData(tData);
    }, [groups, activeRootGroup])

    // 根据节点获得自身及子孙节点的key
    const getAllKeysRecursiveByRootNodes = (rootNodes: TreeNode[], groupUuids: string[] = []) => {
        rootNodes.forEach(node => {
            groupUuids.push(node.key);
            if (node?.children && node.children.length > 0) {
                getAllKeysRecursiveByRootNodes(node.children, groupUuids);  // 递归调用
            }
        })
    }

    const generateTreeData = (groupList: Group[]) => {
        let treeData: TreeNode[] = groupList.map(group => transformGroupToNode(group))
        return treeData
    }

    const transformGroupToNode = (group: Group): TreeNode => {
        let node: TreeNode = {
            key: group.uuid,
            valueCount: 2,
            value1: group.name,
            value2: `${group.primitiveCount || '0'}`,
            type: 1, // 暂时无意义
            children: [],
            customize: group.paramType === GroupParamType.CUSTOMIZE || false
        }
        if (group?.children?.length > 0) {
            group.children.forEach(childGroup => {
                node.children.push(transformGroupToNode(childGroup))
            })
        }
        return node
    }

    /**
     * 监听创建组，放入列表
     */
    useEffect(() => {
        const unsubscribe = engine?.eventMediator?.noticeHandler?.onNotice?.subscribe((sender, event) => {
            if (event.cmd === PythaEventName.DATA_CHANGE) {

                let data = event?.data as DataChangeStruct;
                if (!data) return;

                if (data.add_group != null) {
                    // 创建组
                    let group: Group = data.add_group;
                    group = {
                        ...group,
                        projectUuid: projectUuid,
                    }
                    setGroups([
                        ...groups,
                        group,
                    ])
                }
                if (data.delete_group != null) {
                    let group: Group = data.delete_group;
                    let res = groups.filter(item => item.uuid != group.uuid) || [];
                    setGroups(res);
                }
            }
        });

        return () => {
            unsubscribe?.();
        };
    }, [engine, groups])

    useEffect(() => {
        setLeftItemUpdateUuid(activeRootGroup?.uuid);
    }, [activeRootGroup])

    /**
     * 点击添加按钮，显示添加选项弹窗
     */
    const onAddClick = () => {
        if (!activeRootGroup) {
            // 当前无选中的组，就是加一级组
            onAddRootGroup();
            return;
        }
        let dom = document.getElementById("add-svg")
        if (!dom) return
        const rect = dom.getBoundingClientRect();
        setContextMenuLeft(rect.left - 4);
        setContextMenuTop(rect.bottom + 8);
        setContextMenuVisible(true)
    }

    /**
     * 点击添加按钮，显示添加选项弹窗
     */
    const onUploadClick = () => {
        if (!activeRootGroup) {
            message.info("未选择子组");
            return;
        }
        if (selectedNodes?.length === 0) {
            message.info("未选中子组");
            return;
        } else if (selectedNodes?.length > 1) {
            message.info("只能选中一个子组");
            return;
        }
        let dom = document.getElementById("upload-svg")
        if (!dom) return
        const rect = dom.getBoundingClientRect();
        setThLeft(rect.left - 4);
        setThTop(rect.bottom + 8);
        setThVisible(true);
    }

    /**
     * 添加一级组
     */
    const onAddRootGroup = () => {
        const newGroup: Group = {
            uuid: BaseUtils.genUUID(),
            name: "未命名",
            projectUuid: projectUuid,
            paramType: GroupParamType.CUSTOMIZE,
        }
        addGroup(projectUuid, newGroup).then(res => {
            if (res.status === 200) {
                // 更新前端状态
                setGroups((prevGroups) => [...prevGroups, newGroup]); // 将新组添加到现有列表中
            }
        }).catch((err) => {
            console.error(err);
            message.error("创建一级组时发生错误");
        });
    }

    /**
     * 寻找当前节点所属的一级组
     */
    const getRootGroup = (key: string) => {
        for (let group of groups) {
            if (group.uuid == key) {
                return group;
            }
            let children = group.children || [];
            for (let child of children) {
                if (recursive(child, key)) {
                    return group;
                }
            }
        }
    }

    const recursive = (group: Group, key: string) => {
        if (group.uuid == key) return true;
        let children = group.children || [];
        for (let child of children) {
            if (recursive(child, key)) {
                return true;
            }
        }
        return false;
    }

    /**
     * 添加子组
     */
    const onAddGroup = () => {
        // if (selectedNodes.length != 1) {
        //     message.warning("请先选中一个组");
        //     setContextMenuVisible(false);
        //     return;
        // }
        let parentUuid = null;
        let activeNode = selectedNodes.length != 1 ? null : selectedNodes[0];

        if (!activeNode?.key && activeRootGroup?.uuid) {
            // 只有一级组，没有子组
            parentUuid = activeRootGroup?.uuid;
        } else if (activeNode?.key && activeRootGroup?.uuid) {
            // 判断当前列表是否展示了选中的组，如果没有展示，切换到当前选中组所属的一级组
            let rootGroup = getRootGroup(activeNode?.key);
            if (activeRootGroup?.uuid != rootGroup.uuid) {
                setActiveRootGroup(rootGroup);
            }
            // 子组的子组
            parentUuid = activeNode?.key;
        }
        if (!parentUuid) {
            message.warning("请先选中组");
            setContextMenuVisible(false);
        }

        setContextMenuVisible(false);
        // 添加子组，调用添加组的api

        const newGroup: Group = {
            uuid: BaseUtils.genUUID(),
            name: "未命名",
            projectUuid: projectUuid,
            parentUuid: parentUuid,
            paramType: GroupParamType.CUSTOMIZE,
            children: [],
        }
        addGroup(projectUuid, newGroup).then(res => {
            let newGroups = [...groups];
            let flag = addGroupToParentRecursive(parentUuid, newGroups, newGroup);
            if (flag) {
                setGroups(newGroups);
                if (engine) {
                    engine.storage.groupStore.groupDict[newGroup.uuid] = newGroup;
                }
                if (activeRootGroup?.paramType === GroupParamType.STATUS) {
                    emitter.emit(Emit_Event_Common_Tool.UPDATE_STATUS);
                }
            } else {
                message.error("寻找父组失败");
            }
        }).catch(err => {
            message.error("添加子组失败");
        })
    }

    /**
     * 添加一个node
     * @param parentUuid 
     * @param groups 
     * @param newGroup 
     * @returns 
     */
    const addGroupToParentRecursive = (parentUuid: string, groups: Group[], newGroup: Group): boolean => {
        // 遍历 groups 数组
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            // 如果找到对应的父组
            if (group.uuid === parentUuid) {
                // 如果父组已经存在 children 数组，就将 newGroup 添加进去
                if (!group.children) {
                    group.children = [];
                }
                group.children.push(newGroup);
                // 找到父组并添加成功，返回 true
                return true;
            }

            // 如果当前组有子组，则递归查找子组
            if (group.children && group.children.length > 0) {
                const found = addGroupToParentRecursive(parentUuid, group.children, newGroup);
                // 如果子组中找到并成功添加，直接返回 true
                if (found) {
                    return true;
                }
            }
        }
        // 如果没有找到匹配的 parentUuid，返回 false
        return false;
    };


    // 右键一级分类
    const onContextCategory = (e, item) => {
        e.stopPropagation();
        e.preventDefault();
        if (item.paramType !== GroupParamType.CUSTOMIZE) {
            setCtxUuid(null);
            setActiveRootGroup(item);
            return;
        }
        setRootGroupCtxOpen(true);
        setCtxLeft(e.clientX);
        setCtxTop(e.clientY);
        setCtxUuid(item.uuid);
        setActiveRootGroup(item);
    }

    /**
     * 激活一级组重命名
     * @param DbItem 
     * @returns 
     */
    const onClickEditCategory = (DbItem?: Group) => {
        setRootGroupCtxOpen(false);
        // const group = groups.find(item => item.uuid === ctxUuid);
        let group;
        if (DbItem) {
            // 如果传入了 DbItem
            setCtxUuid(DbItem.uuid);
            group = groups.find(item => item === DbItem);
        } else {
            // 否则继续使用 ctxUuid
            group = groups.find(item => item.uuid === ctxUuid);
        }
        if (!group || group.paramType !== GroupParamType.CUSTOMIZE) {
            return;
        }
        setEditUuid(group.uuid);
        setLeftItemUpdateUuid(BaseUtils.genUUID());
        setInputValue(group.name);
    }

    /**
     * 一级组的重命名功能
     * @param e 
     * @returns 
     */
    const onGroupBlur = (e) => {
        const inputValue = e.target.value;
        if (inputValue == null || inputValue === '') {
            message.warning("分类名称不能为空");
            return;
        }
        const newCategory = {
            name: inputValue,
            projectUuid: projectUuid
        }
        updateGroup(ctxUuid, newCategory).then(res => {
            if (res.status == 200) {
                setEditUuid(null);
                setLeftItemUpdateUuid(BaseUtils.genUUID());
                const group = groups.find(item => item.uuid === editUuid);
                if (!group) return;
                if (inputValue === group.name) return;
                group.name = inputValue;
                setGroups([...groups]);
            }
        }).catch(err => {
            message.error("获取反馈失败")
        })
    }

    /**
     * 删除一级组
     * @returns 
     */
    const onClickDeleteGroup = () => {
        setRootGroupCtxOpen(false);
        const group = groups.find(item => item.uuid === ctxUuid);
        if (!group) return;

        if (group.paramType !== GroupParamType.CUSTOMIZE
        ) {
            message.warning("默认组不可删除");
            return;
        }

        TnModal().deleteModal({
            onOk: () => {
                TnModal().destoryAll();
                //新建传感器类型的接口
                deleteGroup(ctxUuid).then(res => {
                    if (res.status == 200) {
                        // 更新 sensorCategoryList，移除已删除的分类
                        const updatedList = groups.filter(item => item.uuid !== ctxUuid);
                        setGroups(updatedList);

                        // 如果当前选中的分类是被删除的分类，清空选中状态
                        if (activeRootGroup.uuid === ctxUuid) {
                            setActiveRootGroup(null);
                        }
                    }
                }).catch(err => {
                    message.error("获取反馈失败")
                })

            },
            onCancel() {
                TnModal().destoryAll();
            },
        })
    }

    /**
     * 单击激活节点
     * @param node 
     */
    const onClickActiveNode = (e, node: TreeNode) => {
        // 判断当前是否按住ctrl键
        const isCtrl = e.ctrlKey
        const isShift = e.shiftKey;
        dbClickRef.current = false;
        setTimeout(() => {
            if (!dbClickRef.current) {
                let selectedItems = selectedNodes;
                if (isCtrl) {
                    if (selectedItems.some(item => item.key == node.key)) {
                        selectedItems = selectedItems.filter(s => s.key != node.key);
                    } else {
                        selectedItems.push(node);
                    }
                    setSelectedNodes([...selectedItems]);
                } else {
                    setSelectedNodes([node]);
                }
            }
        }, 150)
    }

    /**
     * 编辑一个node
     * @param parentUuid 
     * @param groups 
     * @param newGroup 
     * @returns 
     */
    const updateGroupToParentRecursive = (targetUuid: string, groups: Group[], name: string): boolean => {
        // 遍历 groups 数组
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];

            // 如果找到目标节点，更新它
            if (group?.uuid === targetUuid) {
                group.name = name;
                return true;
            }

            // 如果当前组有子组，则递归查找子组
            if (group?.children && group?.children?.length > 0) {
                const found = updateGroupToParentRecursive(targetUuid, group.children, name);
                // 如果子组中找到并成功更新，直接返回 true
                if (found) {
                    return true;
                }
            }
        }
        return false;
    };

    /**
     * 编辑一个node
     * @param parentUuid 
     * @param groups 
     * @param changeCount 
     * @returns 
     */
    const updateGroupPrimitiveCountToParentRecursive = (targetUuid: string, groups: Group[], changeCount: number, activeUuid: string, addPrimitives, deletePrimitives): boolean => {
        // 遍历 groups 数组
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];

            // 如果找到目标节点，更新它
            if (group?.uuid === targetUuid) {
                group.primitiveCount += changeCount;
                return true;
            }

            // 如果当前组有子组，则递归查找子组
            if (group?.children && group?.children?.length > 0) {
                const found = updateGroupPrimitiveCountToParentRecursive(targetUuid, group.children, changeCount, activeUuid, addPrimitives, deletePrimitives);
                // 如果子组中找到并成功更新，返回 true
                if (found) {
                    let groupUuids = [];
                    getAllGroupUuids(group, groupUuids);
                    groupUuids = groupUuids.filter(item => item != activeUuid);
                    let addCount = 0;
                    let deleteCount = 0;
                    addPrimitives.forEach(pri => {
                        if (groupUuids.some(uuid => pri?.group?.includes(uuid))) {
                            // 在其他组中本来就存在，不新增数量
                        } else {
                            addCount += 1;
                        }
                    })
                    deletePrimitives.forEach(pri => {
                        if (groupUuids.some(uuid => pri?.group?.includes(uuid))) {
                            // 在其他组中本来就存在，不减少数量
                        } else {
                            deleteCount += 1;
                        }
                    })
                    // 总的数量变化
                    let changeCount = addCount - deleteCount;
                    group.primitiveCount += changeCount;
                    return true;
                }
            }
        }
        return false;
    };

    /**
     * 获得rootGroup及其子组的uuid
     * @param rootGroup 
     * @param groupUuids 
     */
    const getAllGroupUuids = (rootGroup: Group, groupUuids: string[] = []) => {
        groupUuids.push(rootGroup.uuid);
        let children = rootGroup.children;
        if (children && children.length > 0) {
            children.forEach((child) => {
                getAllGroupUuids(child, groupUuids)
            })
        }
    }

    /**
     * 更新节点数据
     * @param treeNode 
     * @param value 
     * @param count 
     */
    const updateNode = (treeNode: TreeNode, value: string, count?: number) => {
        if (!projectUuid) return;
        updateGroup(treeNode.key, { projectUuid: projectUuid, name: value }).then(res => {
            let success = updateGroupToParentRecursive(treeNode.key, groups, value);
            if (success) {
                setGroups([...groups]);
            }
        }).catch(e => {
            message.error("修改失败")
        })
    }

    /**
     * 删除节点数据
     * @param treeNode 
     * @param count 
     */
    const deleteNode = (treeNode: TreeNode, count?: number) => {
        const removeGroupByKey = (groups: Group[], key: string): Group[] => {
            return groups
                .filter(group => group.uuid !== key) // 删除匹配的节点
                .map(group => ({
                    ...group,
                    children: group.children ? removeGroupByKey(group.children, key) : [] // 递归处理子节点
                }));
        };

        const updatedGroups = removeGroupByKey(groups, treeNode.key);

        // 更新前端状态
        setGroups(updatedGroups);

        deleteGroup(treeNode.key).then(res => {
            setSelectedNodes([]);
        }).catch(err => {
            message.error("获取反馈失败")
        })
    }

    /**
     * 编辑组图元
     */
    const onEditGroup = () => {
        if (selectedNodes.length != 1) {
            message.warning("请先选中一个组");
            return;
        }
        let activeNode = selectedNodes[0];
        if (!activeNode || !activeNode?.key) {
            message.warning("请先选择组");
            return;
        }
        if (!engine) return;
        setIsActiveGroupEdit(true);
        const event = new PythaEventText();
        event.data = activeNode.key;
        emitCommand("GROUPEDIT")
        engine.eventMediator?.emitEvent(event)
    }

    /**
     * 双击高亮子孙图元
     * @param node
     * @returns
     */
    const onDoubleClickGroup = (node: TreeNode) => {
        dbClickRef.current = true
        // let groupUuids = [];
        // getAllKeysRecursive(node, groupUuids);
        // hightlight(groupUuids);
        return false; // 返回false，阻止组件默认的双击编辑
    }

    /**
     * 获取节点的子孙节点的uuid
     * @param node
     * @param groupUuids
     * @returns
     */
    const getAllKeysRecursive = (node: any, groupUuids: string[] = []): string[] => {
        if (node?.key) {
            groupUuids.push(node.key);  // 将当前节点的 key 加入到数组
        }
        if (node?.children && node.children.length > 0) {
            node.children.forEach((childNode: any) => {
                getAllKeysRecursive(childNode, groupUuids);  // 递归调用
            });
        }
        return groupUuids;  // 返回最终的 key 数组
    }

    /**
     * 高亮组图元
     * @returns
     */
    const hightlight = (groupUuids) => {
        if (!engine) return;
        let primitives = [];
        // 清空选择
        engine.storage.selectStore.selectPrimitives.forEach(p => {
            p.isSelected = false;
            p.needRedraw = true;
        })
        // 选中图元
        Object.keys(engine.storage.primitiveStore.primitiveDict).forEach(key => {
            let primitive = engine.storage.primitiveStore.primitiveDict[key];
            if (groupUuids.some(uuid => primitive?.group?.includes(uuid))) {
                primitive.isSelected = true;
                primitive.needRedraw = true;
                primitives.push(primitive);
            }
        })
        engine.storage.selectStore.selectPrimitives = [...primitives];
        // 渲染
        engine.eventMediator.renderHandler.render(true, UpdateType.MAIN);
    }

    /**
     * 上传前的回调
     */
    const beforeUpload = (file) => {
        if (file.type !== 'image/png') {
            //如果上传的不是图片，则不允许上传
            message.error('只能上传png图片！');
            return false;
        } else {
            return true;
        }
    }

    /**
     * 上传文件完成的回调
     */
    const handleChange = (info) => {
        if (info.file.status === 'done') {
            message.success("上传成功");
            setThVisible(false);
        }
        if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    }


    return (
        <div className='group-panel-container'>
            <SideHeader>
                <div className="header">
                    <span>模型</span>
                    <AddSvg id="add-svg" className='add-icon' onClick={onAddClick} />
                    <BindSvg onClick={onEditGroup} className={classNames({
                        "btn-active": isActiveGroupEdit
                    })} />
                    <UploadSvg id="upload-svg" className='add-icon' onClick={onUploadClick} />
                </div>
            </SideHeader>
            <LeftSideList wrapClassName="group-list"
                minStyle={true} leftItems={groups} uniqueKey='uuid'
                leftItemUpdateUuid={leftItemUpdateUuid} activeLeftItemKey={activeRootGroup?.uuid || ''} noNeedAddIcon
                onClickLeftItem={(e, item) => {
                    setActiveRootGroup(item);
                    // setActiveNode(null) 
                }} //设置左侧激活对象，将其存入选中对象，用于添加
                onContextMenuLeftItem={(e, item) => onContextCategory(e, item)}
                onDbClickLeftItem={(e, item) => { onClickEditCategory(item) }}
                leftItemContainer={({ leftItem }) => {
                    return (
                        <>
                            {editUuid !== leftItem.uuid && <div title={leftItem.name} className="first-level group-first-level ellipsis">{leftItem.name}</div>}
                            {editUuid === leftItem.uuid && <Input defaultValue={inputValue} autoFocus onBlur={onGroupBlur} onEnter={onGroupBlur} />}
                        </>
                    );
                }}>
                <div className="right-body">
                    <TreeComponent
                        showItemKey={showItemKey}
                        // 禁止点击空白处清空激活
                        clickEmptyToCleanActive={false}
                        // activeNode={activeNode}
                        selectedNodes={selectedNodes}
                        treeList={treeData}
                        onClickNode={(e, node) => onClickActiveNode(e, node)}
                        // 双击显示
                        onDoubleClickItem={onDoubleClickGroup}
                        onEditNodeConfirm={(node: TreeNode, value, count) => {
                            updateNode(node, value, count)
                        }}
                        onDeleteNodeConfirm={(node: TreeNode, count) => {
                            deleteNode(node, count)
                        }}
                    />
                </div>
            </LeftSideList>

            <ContextMenu
                visible={contextMenuVisible}
                left={contextMenuLeft}
                top={contextMenuTop}
                width={54}
                onCancel={() => { setContextMenuVisible(false) }}
            >
                <MenuList>
                    <MenuItem onClick={() => {
                        onAddRootGroup()
                        setContextMenuVisible(false)
                    }}>
                        一级组
                    </MenuItem>
                    <MenuItem onClick={() => {
                        onAddGroup()
                        setContextMenuVisible(false)
                    }}>
                        子组
                    </MenuItem>
                </MenuList>
            </ContextMenu>

            <ContextMenu visible={rootGroupCtxOpen} left={ctxLeft} top={ctxTop} onCancel={() => setRootGroupCtxOpen(false)}>
                <MenuList>
                    <MenuItem onClick={() => onClickEditCategory(null)}>重命名</MenuItem>
                    <MenuItem special onClick={onClickDeleteGroup}>删除</MenuItem>
                </MenuList>
            </ContextMenu>

            <ContextMenu
                visible={thVisible}
                left={thLeft}
                top={thTop}
                width={100}
                onCancel={() => { setThVisible(false) }}
            >
                <MenuList>
                    <MenuItem>
                        <Upload name='file'
                            data={{ 'projectUuid': projectUuid, 'field': 'unselected_base64', uuid: selectedNodes[0]?.key }}
                            showUploadList={false}
                            action={GroupThumbnailUploadUrl}
                            onChange={handleChange}
                            beforeUpload={beforeUpload}
                        >
                            未选中缩略图
                        </Upload>
                    </MenuItem>
                    <MenuItem>
                        <Upload name='file'
                            data={{ 'projectUuid': projectUuid, 'field': 'selected_base64', uuid: selectedNodes[0]?.key }}
                            showUploadList={false}
                            action={GroupThumbnailUploadUrl}
                            onChange={handleChange}
                            beforeUpload={beforeUpload}
                        >
                            选中缩略图
                        </Upload>
                    </MenuItem>
                </MenuList>
            </ContextMenu>
        </div>
    )
}
